module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAABCklEQVRoQ+2X0RGCMBBENxUoHWgHlIYViBVIaXSgNiB0gOP4DceEI6xk833J7e3bycwF7PyEnc8HDfjvhEVQBMkdUETJAZnyRNC0iLwgc4JVVwK4AjiSguoB3NAU7Zi+aYJV90DAiXS4n6wBTzTFOW7Ay7sHwoF6QOCFezEKwSJYIqCmjuiAOj6i5OjmyMv8F51jEXmNCJIDMuWJoGkReYEIkgMy5WVOUNuEmZD1C7RNTHn8jai2ifVTuKRD5r/oEutI7oogCYhoGSIYbR3JRREkAREtI3OC2iaik+N3UduEtgm/NG3xUua/6BaWO/cUQWdDkz8ngsktd24ogs6GJn9OBJNb7txw9wQ/olM8Obzeen4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/20.png
// module id = U5kr
// module chunks = 1